import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from '@/components/atoms';

const InfoLabel = ({title, id, className = ''}) => {
  return (
    <span
      data-testid={`info-label` + (id ? `_${id}` : '')}
      className={`inline-flex items-center gap-2 rounded-lg border border-[color:var(--color-feedback-info-default)] bg-[color:var(--color-feedback-info-background)] px-3 py-1 text-sm text-[color:var(--color-text-high-contrast)] ${className}`.trim()}>
      <Icon
        alt=''
        icon='info'
        size='small'
        className='shrink-0 text-[color:var(--color-text-high-contrast)]'
      />
      {title}
    </span>
  );
};

InfoLabel.propTypes = {
  title: PropTypes.node.isRequired,
  id: PropTypes.string,
  className: PropTypes.string
};

export default React.memo(InfoLabel);
